"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePunchWorkflowContext = exports.PunchWorkflowContextProvider = exports.PunchWorkflowContext = void 0;
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
exports.PunchWorkflowContext = (0, react_1.createContext)({
    selectedDateTime: luxon_1.DateTime.now(),
    associateInfo: undefined,
    featureGates: {},
    isActionable: true,
    selectedPunchList: [],
    action: undefined,
    selectedPunchTime: undefined,
    newPunchTime: '',
    newPunchDate: luxon_1.DateTime.now(),
    useMilitaryTime: false,
    addPunchLockedOutStatus: undefined,
    editPunchLockoutStatus: undefined,
    showErrorFallback: false,
    payPeriodBreakdownInfo: undefined,
    punchesForMealLockoutValdn: undefined,
    isSubmitting: false,
    setIsCurrentStepValid: undefined,
    setCurrentStepTitle: undefined,
    setSelectedDateTime: undefined,
    setIsActionable: undefined,
    setTotalSteps: undefined,
    setSelectedPunchList: undefined,
    setAction: undefined,
    setSelectedPunchTime: undefined,
    setNewPunchTime: undefined,
    setNewPunchDate: undefined,
    setUseMilitaryTime: undefined,
    setAddPunchLockedOutStatus: undefined,
    setEditPunchLockoutStatus: undefined,
    setShowErrorFallback: undefined,
    setPayPeriodBreakdownInfo: undefined,
    setPunchesForMealLockoutValdn: undefined
});
const PunchWorkflowContextProvider = ({ punchWorkflowInitial, children }) => (react_1.default.createElement(exports.PunchWorkflowContext.Provider, { value: Object.assign({}, punchWorkflowInitial) }, children));
exports.PunchWorkflowContextProvider = PunchWorkflowContextProvider;
const usePunchWorkflowContext = () => (0, react_1.useContext)(exports.PunchWorkflowContext);
exports.usePunchWorkflowContext = usePunchWorkflowContext;
